export const REGEXP = {
  apiContextSegment: /\/api\/([^/]+)/,
  screenIdExclusion: /[/\-]/g, // eslint-disable-line no-useless-escape
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,}$/
};
